import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { updateMemberPassword } from "../../../services/memberServices";
import { logout } from "../../../services/authServices";

import usePasswordConfirm from "../../../hooks/usePasswordConfirm";
import useFullScreenLoading from "../../../hooks/useFullScreenLoading";

import StickyHeader from "../../../components/Layout/StickyHeader";
import HorizontalRule from "../../../components/Rule/Horizontal";
import BottomButtonGroup from "../../../components/Button/Bottom";
import CommonPopup from "../../../components/Popup";
import CommonButton from "../../../components/Button";
import SimplePopup from "../../../components/Popup/Simple";

import emailDupConfirm from "../../../assets/img/email-dup-confirm.png";

type Props = {};

export default function MyInfoChangePassword(props: Props) {
  const navigate = useNavigate();
  const [
    {
      data: passwordConfirmData,
      isComplete: isCompletePassword,
      validate: validatePasswordConfirm,
    },
    passwordConfirmComponent,
  ] = usePasswordConfirm({ fieldName: "새 비밀번호" });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const loadingComponent = useFullScreenLoading({ isLoading });
  const [popup, setPopup] = useState<
    "completeChangePassword" | "failedChangePassword" | ""
  >("");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="flex flex-col justify-between min-h-content z-30">
      {loadingComponent}
      <div className="px-5">
        <StickyHeader
          title="비밀번호 변경"
          onBackClick={() => navigate("/myinfo")}
        />

        <div className=" text-3xl whitespace-pre-line font-normal pb-3 pt-5">
          <strong>비밀번호 변경</strong>
          {"을\n도와드릴게요"}
        </div>

        <HorizontalRule className="my-[33px]" />

        <div className="flex flex-col gap-5">{passwordConfirmComponent}</div>
      </div>
      <BottomButtonGroup
        title="비밀번호 변경"
        validation={
          !isCompletePassword || passwordConfirmData.password.length < 8
        }
        onClick={async () => {
          if (!validatePasswordConfirm()) return;

          setIsLoading(true);
          try {
            await updateMemberPassword({
              password: passwordConfirmData.password,
            });
          } catch (e) {
            setPopup("failedChangePassword");
          }
          setIsLoading(false);

          setPopup("completeChangePassword");
        }}
      />

      <CommonPopup
        title="비밀번호 재설정 완료"
        isOpen={popup === "completeChangePassword"}
        padding={0}
        unUseHorizonRule
      >
        <div className="px-5 pb-5">
          <div className="py-2.5 flex flex-col gap-2.5 items-center">
            <img src={emailDupConfirm} alt="dup-confirm" className="h-[60px]" />
            <div className=" whitespace-pre-line text-center text-brand-neutral-60 text-sm">
              {"비밀번호 변경에 성공하였습니다"}
            </div>
          </div>
        </div>

        <CommonButton
          className="h-bottom-button w-full rounded-none"
          onClick={() => {
            logout();
            navigate("/auth/login");
          }}
        >
          로그인 페이지로 이동
        </CommonButton>
      </CommonPopup>

      <SimplePopup
        message={"비밀번호 변경에 실패하였습니다.\n매니저에게 문의해주세요."}
        isOpen={popup === "failedChangePassword"}
        onClose={() => setPopup("")}
      />
    </div>
  );
}
